import styled from 'styled-components';
import is from 'styled-is';

import { fontSizeAdaptative, textSizes } from 'utils/style';

import Link from 'components/styled/link/component';

export default styled(Link)`
  font-size: ${textSizes('L')};

  ${fontSizeAdaptative};
  ${is('noTextDecoration')`
    & {
      text-decoration: none;
    }
  `};
`;
